const ADD_EVENT_TO_REFERENCE_DATA = (state, payload) => {
  state.referenceData.eventTypes.push(payload);
};

export default ADD_EVENT_TO_REFERENCE_DATA;
